/* file description */

export const BUTTONLIST = [
  {
    label: '复制', // 复制按钮
    type: 'copy-btns',
    props: {
      type: 'primary',
    },
  },
  {
    label: '编辑', // 编辑按钮
    type: 'edit-btns',
    props: {
      type: 'primary',
    },
  },
  {
    label: '关闭', // 关闭按钮
    type: 'close-btns',
    props: {},
  },
  {
    label: '删除', // 删除按钮
    type: 'delete-btns',
    props: {
      type: 'primary',
      danger: true,
    },
  },
  {
    label: '保存', // 保存按钮
    type: 'save-btns',
    props: {
      type: 'primary',
    },
  },
  {
    label: '提交审批', // 提交按钮
    type: 'submit-btns',
    props: {
      type: 'primary',
    },
  },
];
export const ADDPAGEBTN = ['close-btns', 'save-btns'];
export const EDITPAGEBTN = ['close-btns', 'save-btns'];
export const DETAILEPAGEBTN = [];
export const pageObj = {
  add: ADDPAGEBTN,
  edit: EDITPAGEBTN,
  view: DETAILEPAGEBTN as string[],
};

export type btnListType = typeof BUTTONLIST;
